import { gql } from '@apollo/client';

// Staff management queries
export const STAFF_BY_UUID = gql`
    query StaffByUuid($uuid: String!) {
        staffByUuid(uuid: $uuid) {
            id
            uuid
            active
            person {
                uuid
                forename
                name
            }
            staffServices {
                service {
                    id
                    uuid
                    name
                }
            }
            workingHours {
                id
                dayOfWeek
                startTime
                endTime
                breaks {
                    startTime
                    endTime
                }
            }
        }
    }
`;
